import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from './authGuard'

import Connect from '../components/Connect'
import AutoConnect from '../components/AutoConnect'
import AssignmentsList from '../components/lesson/AssignmentsList'
import Question from '../components/question/Question'
import CoachValidation from '../components/lesson/CoachValidation'
import Patience from '../components/misc/Patience'
import { constants } from '../constants'


Vue.use(Router)

export const router = new Router({
  routes: [
    { 
      path: '/connect/:token',
      name: 'connect_param', 
      component: Connect,
    },
    { 
      path: '',
      name: 'connect', 
      component: Connect,
    },
    { 
      path: '/assignments',
      name: 'assignments', 
      component: AssignmentsList,
      beforeEnter: AuthGuard,
    },
    { 
      path: '/question',
      name: 'question', 
      component: Question,
      beforeEnter: AuthGuard,
    },
    { 
      path: '/validation',
      name: 'validation', 
      component: CoachValidation,
      beforeEnter: AuthGuard,
    },
    { 
      path: '/patience',
      name: 'patience', 
      component: Patience,
      beforeEnter: AuthGuard,
    },
    { 
      path: '/test',
      name: 'test', 
      component: Connect,
    },
    { 
      path: "/:token", 
      component: AutoConnect,
    },
    { 
      path: "*", 
      component: Connect,
    }
  ],
  mode: 'history',
  base: constants.project.path + '/',
})



// WEBPACK FOOTER //
// ./src/router/router.js